import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../component/mainAdmin/Header";
import SideBar from "../../component/mainAdmin/SideBar";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewCourseData,
  emptyMessage,
} from "../../Redux/action/courseAction/index";
import Modal from "react-awesome-modal";
import NewSideBar from "../../component/mainAdminComponents/newSideBar";
import {addtoCourseList, getAllCourseList,deletefromcourseList} from '../../Redux/action/courseList'
import { ToastContainer } from "react-toastify";
import { GoTrash } from "react-icons/go";


const CourseList = () => {

    
    const [showModal,setshowModal] = useState(false)
    
    const {courseList,loading,addloading,deleteloading} = useSelector(state => state.courseListReducer)
    console.log(courseList,loading)
    
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getAllCourseList())
    },[])

    const [courseName,setcourseName] = useState('')
    const [courseCode,setcourseCode] = useState('')

    const addcourse = () => {
        dispatch(addtoCourseList(courseName,courseCode,setshowModal))
        setcourseName('')
        setcourseCode('')
    }

  return (
    <>
      <ToastContainer />
      <Header />
      <div className="sidebar-banner-container" style={{ display: "flex" }}>
        <NewSideBar />

        <div className="container-fluid">
        <Modal
            visible={showModal}
            width="400"
            height="240"
            effect="fadeInUp"
            onClickAway={() => setshowModal(false)}
          >

              <div>  
                  <div style={{ margin:"10px auto",width:"100%" }}>
                <h4 className="color text-center">Add New Course</h4>

                  </div>
                <div style={{width:'90%',margin:"auto"}}>
              <input
                value={courseName}
                className="inp"
                placeholder="Course Name"
                onChange={(e) => {
                  setcourseName(e.target.value);
                }}
              />
            </div>
                <div style={{width:'90%',margin:"auto"}}>
              <input
                value={courseCode}
                className="inp"
                maxLength={5}
                placeholder="Course Code"
                
                onChange={(e) => {
                  setcourseCode(e.target.value.toUpperCase());
                }}
              />
            </div>
        <div style={{display:'flex',alignItems: 'center',justifyContent: 'center',flexDirection: 'column'}}>

{addloading ? (
     <div className="spinner-border load" role="status" style={{}}>
                <span className="visually-hidden"></span>
              </div> 
) : (
            <div className="mt-2">
              <button
                className="prevbtn"
                style={{ width: 150, height: 40 }}
                onClick={addcourse}
              >
                Add 
              </button>
              
          </div>

)}
          </div>
              </div>
            
          </Modal>
        <div style={{display:'flex',alignItems: 'center',justifyContent: 'center',flexDirection: 'column'}}>
        <div className="col-md-8 p-2 text-white text-center">
              <h1 className="color title fs-2">Course List</h1>
            </div>
            <div className="mb-1">
              <button
                className="prevbtn"
                style={{ width: 150, height: 40 }}
                onClick={() => {
                  setshowModal(true)
                }}
              >
                Add Course to List
              </button>
              
          </div>
          {courseList.map((e,i) => {
            return (
<div style={{minWidth:"380px",marginTop:8,maxWidth:"auto",borderRadius:8,padding:"7px",display:"flex",alignItems:"center",justifyContent:"space-around",backgroundColor:"#fff",boxShadow:"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}}>
            <p style={{fontSize:"17px",color:"#222",fontFamily:"Poppins",margin:"0px 6px",width:"80%"}}>{e.courseName}</p>
            <p style={{fontSize:"17px",color:"#222",fontFamily:"Poppins",margin:"0px 6px",width:"10%"}}>{e.courseCode}</p>
            <div style={{margin:"0px 6px",width:"10%",cursor:"pointer"}} onClick={() => dispatch(deletefromcourseList(e._id))}>
                <GoTrash size={22} color="crimson" />
            </div>
          </div>
            )
          })}
           
        </div>
        </div>
      </div>
    </>
  );
};

export default CourseList

{/* <div className="spinner-border load" role="status" style={{}}>
                <span className="visually-hidden"></span>
              </div> */}
